namespace $ { export class $piterjs_screen_lines extends $mol_svg_root {

	/**
	 *  ```
	 *  style * fill <= color
	 *  ```
	 **/
	style() {
		return ({
			"fill" :  this.color() ,
		})
	}

	/**
	 *  ```
	 *  color \#FFE515
	 *  ```
	 **/
	color() {
		return "#FFE515"
	}

	/**
	 *  ```
	 *  view_box \0 0 310 246
	 *  ```
	 **/
	view_box() {
		return "0 0 310 246"
	}

	/**
	 *  ```
	 *  sub /
	 *  	<= First
	 *  	<= Second
	 *  	<= Third
	 *  ```
	 **/
	sub() {
		return [this.First() , this.Second() , this.Third()] as readonly any[]
	}

	/**
	 *  ```
	 *  First $mol_svg_path geometry \M56 9.00002L-1.5605e-05 67.5L-1.31571e-05 95.5L56 36.5L56 9.00002Z
	 *  ```
	 **/
	@ $mol_mem
	First() {
		return (( obj )=>{
			obj.geometry = () => "M56 9.00002L-1.5605e-05 67.5L-1.31571e-05 95.5L56 36.5L56 9.00002Z "
			return obj
		})( new this.$.$mol_svg_path(  ) )
	}

	/**
	 *  ```
	 *  Second $mol_svg_path geometry \M148.5 1.40751e-05L-7.6932e-06 158L0 246L238 6.25073e-06L148.5 1.40751e-05Z
	 *  ```
	 **/
	@ $mol_mem
	Second() {
		return (( obj )=>{
			obj.geometry = () => "M148.5 1.40751e-05L-7.6932e-06 158L0 246L238 6.25073e-06L148.5 1.40751e-05Z"
			return obj
		})( new this.$.$mol_svg_path(  ) )
	}

	/**
	 *  ```
	 *  Third $mol_svg_path geometry \M167.5 152.5L167.5 108L268 3.62805e-06L309.5 0L167.5 152.5Z
	 *  ```
	 **/
	@ $mol_mem
	Third() {
		return (( obj )=>{
			obj.geometry = () => "M167.5 152.5L167.5 108L268 3.62805e-06L309.5 0L167.5 152.5Z"
			return obj
		})( new this.$.$mol_svg_path(  ) )
	}

} }
